
<input type="tel" class="p-inputtext p-component p-element w-full" #phoneNumberField [disabled]="isDisabled">
<div *ngIf="intElement && isTouched && !intElement.isValidNumber() && intElement.getNumber().length>0">
    <small class="form-text p-error" i18n="@@phone-number-input.not-valid">This is not a valid phone number</small>

</div>